module.exports = __webpack_public_path__ + "static/media/SXVS4841.ed4c7f4f.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/make_over/SXVS4841.JPG
// module id = 322
// module chunks = 0